import fineTuneVideosView from './fineTuneVideosView.html';
import './fineTuneVideosStyles.css';
import { DateRangeCalculator } from 'components/sharpr/date/dateRangeCalculator/DateRangeCalculator';
import _ from 'lodash';

export default function fineTuneVideosComponent() {
	return {
		bindings: {
			hubs: '=',
			playlist: '=',
		},
		controllerAs: 'vm',
		controller: fineTuneVideosComponentCtrl,
		template: fineTuneVideosView,
	};
}

class fineTuneVideosComponentCtrl {
	/**
	 * @param $scope  The scope of the component element
	 * @param Api
	 * @param $q
	 * @param FineTuneVideos
	 * @param Identity
	 * @param modal
	 */
	constructor($scope, Api, $q, FineTuneVideos, Identity, modal) {
		'ngInject';
		// save injections
		/**
		 * The Api service instance
		 * @type Api
		 */
		this.Api = Api;
		/**
		 * The $q service instance
		 * @type $q
		 */
		this.$q = $q;
		/**
		 * The Identity service instance
		 * @type Identity
		 */
		this.Identity = Identity;
		/**
		 * The FineTuneVideos service instance
		 * @type FuneTuneVideos
		 */
		this.FineTuneVideos = FineTuneVideos;
		/**
		 * The modal service instance
		 * @type modal
		 */
		this.modal = modal;
		// setup
		/**
		 * The string names of the date presets
		 * @type {String[]}
		 */
		this.datePresetNames = DateRangeCalculator.getPresetNames();
		/**
		 * The initial search parameters
		 * @type {Object}
		 */
		this.search = this._getDefaultSearch();
		/**
		 * An array of results
		 * @type {Array}
		 */
		this.results = [];
		/**
		 * The list of videos that were chosen
		 * @type {Array}
		 */
		this.chosen = [];
		/**
		 * Whether we have initialized a search or not
		 * @type {Boolean}
		 */
		this.isSearchMode = false;
		$scope.$watch('vm.search', () => this.loadResults(), true);
		$scope.$watch('vm.hubs', () => this.loadResults(), true);
		this.loadResults = _.throttle(this.loadResults, 250, { leading: false, trailing: true });
		this.loadPlaylist();
	}

	/**
	 * Fetch results based on the passed search
	 */
	runSearch() {
		this.isSearchMode = true;
		this.loadResults();
	}

	/**
	 * Get the default search parameters
	 * @returns {Object}
	 * @private
	 */
	_getDefaultSearch() {
		return {
			datePreset: 'all',
			dateStart: null,
			dateEnd: null,
		};
	}

	/**
	 * Open the modal and play the video
	 * @param {Object} video
	 */
	play(video) {
		this.modal.video(video, {
			height: 'full',
			width: 'full',
		});
	}

	/**
	 * Load the list of chosen videos
	 */
	loadPlaylist() {
		if (!this.playlist || this.playlist.length === 0) {
			// empty playlist
			return;
		}
		let search = { ids: this.playlist };
		let options = { hubs: 'mine' };
		this.FineTuneVideos.fetch(search, options).then(videos => (this.chosen = videos));
	}

	/**
	 * Add a video to the list of chosen videos
	 * @param {Object} video
	 */
	addVideo(video) {
		video.chosen = true;
		this.chosen.push(video);
		this.updatePlaylist();
	}

	/**
	 * Remove a video from the list of chosen videos
	 * @param {Object} video
	 */
	removeVideo(video) {
		video.chosen = false;
		this.chosen.splice(this.chosen.indexOf(video), 1);
		this.updatePlaylist();
	}

	/**
	 * Update the playlist based on the chosen videos
	 */
	updatePlaylist() {
		this.playlist = _.pluck(this.chosen, 'id');
	}

	loadResults() {
		let search = _.extend({ not_ids: this.playlist }, this.search);
		let options = {
			hubs: this.hubs,
		};
		this.hasCriteria = this._hasAnySearchParams();
		this.isSearching = true;
		this.FineTuneVideos.fetch(search, options).then(videos => {
			this.results = videos;
			this.isSearching = false;
		});
	}

	_hasAnySearchParams() {
		return this.search.datePreset != 'all' || this.search.term;
	}
}
